<template>
    <div class="bg-register">
        <!-- <SwitchLang></SwitchLang> -->
        <img @click="clickBack()" class="ic-back" src="../../../assets/icon/ic-back.svg" />
        <div>
            <img class="bhp-logo" src="@/assets/img/bh_logo/bhp-logo-white.svg" alt="">
        </div>
        <div class="bg-form-register">
            <img class="bg-top" src="@/assets/img/bg-white-top.png" alt="">
            <div class="otp-wrapper">
                <div class="otp-title">{{ lbl.register.otp_title }}</div>
                <div class="otp-send-to">{{ lbl.register.otp_send_to }}</div>
                <div class="otp-mobile-no">{{ contactNumberDisplay }}</div>
                <div class="otp-refcode">{{ lbl.register.otp_refcode }} {{refcode}}</div>

                <div class="row">
                    <div class="col-12 text-center">
                        <div>
                            <label for="input-otp" >
                                <div class="d-flex justify-content-center" >
                                    <div class="box-input-otp" :class="{'error': isOtpError}">{{otp[0]}}</div>
                                    <div class="box-input-otp" :class="{'error': isOtpError}">{{otp[1]}}</div>
                                    <div class="box-input-otp" :class="{'error': isOtpError}">{{otp[2]}}</div>
                                    <div class="box-input-otp" :class="{'error': isOtpError}">{{otp[3]}}</div>
                                    <div class="box-input-otp" :class="{'error': isOtpError}">{{otp[4]}}</div>
                                    <div class="box-input-otp" :class="{'error': isOtpError}">{{otp[5]}}</div>
                                </div>
                            </label>
                        </div>
                        <input type="tel"
                            id="input-otp"
                            class="input-otp-dummy"
                            maxlength="6"
                            v-model="otp"
                            @input="onOtpChange()">
                    </div>
                </div>
                <div v-if="isExpireTime" class="resend_otp" @click="resendOtp()">{{ lbl.register.send_otp_again }}</div>
                <div v-if="!isExpireTime" class="otp-resend">{{ lbl.register.resend_otp }} <span class="time">{{timeHelper.displayTime}}</span></div>

                <div v-if="isOtpError" class="error-wrapper">
                    <!-- <div class="text-error">{{error.message}}</div> -->
                    <div class="text-error">{{ lbl.register.invalid_code }}</div>
                    <div class="text-error">{{ lbl.register.error_code }}{{error.code}}</div>
                </div>
                <div class="btn-wrapper">
                    <button v-if="otp.length == 6 && !isExpireTime" class="btn-orange" @click="clickRegister()">{{lbl.register.verify}}</button>
                    <button v-else class="btn-gray">{{lbl.register.verify}}</button>
                </div>
                <img class="logo-bzbs" src="../../../assets/bzbslogo/bzbs-logo.svg" />
            </div>
        </div>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
import Vue from 'vue';
import Locale from '@/helper/locale/locale.js';
// import SwitchLang from '../component/SwitchLang.vue';
import TimerHelper from "@/helper/TimerHelper.js";
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
//service
import BzbsAuth from '@/core/Account/service/BzbsAuth';
import RegisterService from '../service/RegisterService.js';
import DateTimeHelper from '@/helper/DatetimeHelper.js';
//components
import LocaleMixin from '@/mixin/LocaleMixin.js';

export default {
    name: "registerotp",
    components: {

        ModalMaster,
        // SwitchLang,
    },
    mixins: [LocaleMixin],
    data: function() {
        return {
            lbl: Locale.getLbl(),
            otp: '',
            refcode: '',
            contactNumber: "",
            contactNumberDisplay: "",

            timeHelper: new TimerHelper(),

            loadingModal: null,
            isExpireTime: false,
            isOtpError: false,
            error: "",
            formData: null,
            isAcceptTerms: false,
            getGender: null,
            cacheFormOtp: null,
            displayTime: '',
            isUserActive: true,
            currentTimeMinutes: null
        }
    },
    created: function() {
        let modalFactory = new ModalFactory();
        this.modalController = modalFactory.getModalController();
        this.loadingModal = modalFactory.getLoadingModal();
        this.alertModal = modalFactory.getAlertModal();
        this.registerSuccessModal = modalFactory.getRegisterSuccessModal();

        let cacheFormData = window.sessionStorage.getItem('form_register');
        this.formData = JSON.parse(cacheFormData);

        let cacheisAcceptTerms = window.sessionStorage.getItem('accept_terms_privacy');
        this.isAcceptTerms = JSON.parse(cacheisAcceptTerms);
        this.contactNumber = this.formData.contact_number;
        
    },
    mounted: function() {
        this.mobileFormat();
        this.startOtp();
    },
    methods: {
        mobileFormat: function () {
            var n1, n2;

            n1 = this.contactNumber.substr(0, 3);
            n2 = this.contactNumber.substr(3, 3);
            this.contactNumberDisplay = n1 + "-" + n2 + "-" + "XXXX";

        },
        onOtpChange: function() {
            this.otp = this.otp.replace(/\D/g, '');
        },
        startOtp: async function() {
            this.isExpireTime = false;
            this.otp = '';
            this.refcode = '';
            document.addEventListener('visibilitychange', this.checkUserActive, false);
            this.refcode = this.formData.refcode;
            if (this.refcode != '') {
                let timeDiffInSecond = await this.diffTimeOtp();
                    if(timeDiffInSecond < 0) {
                        this.isExpireTime = true;
                    return;
                }
                this.initTimer(timeDiffInSecond);
            }
        },
        initTimer: function (diffTime) {
            this.timeHelper.initialTimer(diffTime, null, false, false);
            this.isExpireTime = false;
            this.timeHelper.runTimer((display) => {
                this.displayTime = display;
            }, () => {
                this.setTimeout();
            });
        },
        diffTimeOtp: function () {
            let date = new Date();
            let expireDateMinutes = date.getMinutes() + 3;
            let currentTime = new Date()
            this.currentTimeMinutes = currentTime.getMinutes();
            let difMinute = expireDateMinutes - this.currentTimeMinutes;
            if (difMinute >= 1) {
                this.displayTime = difMinute * 60;
            } else {
                difMinute = 3
                this.displayTime = difMinute * 60;
            }
            return this.displayTime;
        },
        checkUserActive: function () {
            this.isUserActive = !document.hidden;
            if(!this.isUserActive){
                this.timeHelper.stopTimer();
                window.sessionStorage.setItem('timer', this.currentTimeMinutes);
            }else{
                this.setTimer();
            }
        },
        setTimer: function() {
            let time = window.sessionStorage.getItem('timer');
            let date = new Date();
            let expireDateMinutes = date.getMinutes();
            let difMinute = expireDateMinutes - time;
            let secound = difMinute * 60;
            this.initTimer(secound);
        },
        setTimeout: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.isExpireTime = true;
            document.removeEventListener('visibilitychange', this.checkUserActive, false);
            window.sessionStorage.removeItem('timer');
        },
        cancelOtp: function() {
            this.timeHelper.stopTimer();
            this.timeHelper.resetTimer();
            this.hide();
            this.controller.sendCallbackCancel();
        },
        resendOtp: async function() {
            this.loadingModal.show();
            this.isExpireTime = false;
            this.isOtpError = false;
            this.refcode = '';
            this.otp = '';
            this.error = '';
            this.cacheFormOtp = await this.genFormData();
            document.addEventListener('visibilitychange', this.checkUserActive, false);
            var success = await RegisterService.apiVerifyRegister(this.cacheFormOtp);
            this.refcode = success.data.refcode;
            if (success) {
                this.loadingModal.hide();
                let timeDiffInSecond = await this.diffTimeOtp();
                    if(timeDiffInSecond < 0) {
                        this.isExpireTime = true;
                    return;
                }
                this.initTimer(timeDiffInSecond);
            }
        },
        clickRegister: function () {
            this.loadingModal.show();
            return new Promise((resolve) => {

                let params = this.getParamsRegister();
                BzbsAuth.apiregisterv2(params)
                    .then(result => {
                        this.isOtpError = false;
                        this.removeCacheFormForShow();
                        this.loadingModal.hide();
                        this.registerSuccessModal.show()
                        this.registerSuccessModal.onClickOk(data => {
                            //openlick
                            console.log(data);
                            window.open(`${Vue.bzbsConfig.miscUrl}/landing/openapp.html?appname=bhpetrol`)
                            console.log("click confirm");
                            this.$router.replace("/register/ecard");
                        });
                        this.registerSuccessModal.onHidden(data => {
                            //openlick
                            console.log(data);
                            console.log("click confirm");
                            this.$router.replace("/register/ecard");
                        });
                        document.removeEventListener('visibilitychange', this.checkUserActive, false);
                        resolve(result)
                    })
                    .catch((error) => {
                        this.error = error.response.data.error
                        this.isOtpError = true;
                        this.loadingModal.hide();
                    });
            });
        },
        genFormData: function() {
            let personalId = '';
            if (this.formData.personal_id_type.value == "NRIC") {
                let id = this.formData.personal_id.split('-');
                personalId = id[0]+id[1]+id[2];
            } else {
                personalId = this.formData.personal_id;
            }
            if (this.localeCode == '1033') {
                this.formData.language = 'English';
            } else if (this.localeCode == '1086') {
                this.formData.language = 'Malaysia';
            } else {
                this.formData.language = 'Chinese';
            }
            const data = {
                personal_id: personalId,
                contact_number: this.formData.contact_number,
                country_code: this.formData.country_code,
                language: this.formData.language,
                username: this.formData.contact_number,
                email: this.formData.email,
                referral_code: this.formData.referralcode
            }

            return data;
        },
        getParamsRegister: function () {
            let birthDate = this.formData.birthdate
            let personalId = '';
            if (this.formData.personal_id_type.value == "NRIC") {
                birthDate = this.getBirthDate(this.formData.personal_id)
                let id = this.formData.personal_id.split('-');
                personalId = id[0]+id[1]+id[2];
            } else {
                birthDate = "";
                personalId = this.formData.personal_id;
            }
            if (this.formData.gender.length > 0) {
                this.getGender = this.formData.gender[0].value;
            } else {
                this.getGender = this.formData.gender.value;
            }
            
            let params = {
                personal_id: personalId || '',
                personal_id_type: this.formData.personal_id_type.value || '',
                contact_number: this.formData.contact_number || '',
                contact_number_prefix: this.formData.country_code || '',
                username: this.formData.username || '',
                email: this.formData.email || '',
                password: this.formData.password || '',
                fullname: this.formData.fullname || '',
                nameOnCard: this.formData.nameOnCard || '',
                language: this.formData.language || '',
                maritalStatus: '',
                race: this.formData.race.value || '',
                nationality: '',
                address: '',
                otp: this.otp || '',
                refcode: this.refcode || '',
                birthdate: birthDate || '',
                device_app_id: Vue.bzbsConfig.client_id || '',
                referralcode: this.formData.referralcode || '',
                gender: this.getGender,
            }
            return params
        },
        getBirthDate: function (id) {
            let day = id.substr(4, 2)
            let month = id.substr(2, 2)
            let year = id.substr(0, 2)
            // let monthFormat = month
            if (month > 12) {
                month = "12"
            }
            if (month < 10) {
                month = month.substr(1, 1)
            }
            if (year <= 30) {
                year = "20" + year;
            } else {
                year = "19" + year;
            }
            const lastDayOfMonth = new Date(year, month, 0);
            let lastday = lastDayOfMonth.getDate();
            if (parseInt(day) > parseInt(lastday)) {
                day = lastday;
            }
            console.log("date", day + "/"+ month + "/" + year)
            let date = new Date(year, month-1, day)
            let dateTimeStamp = DateTimeHelper.convertDateToTimeStampUnix(date)
            return dateTimeStamp
        },
        clickBack: function () {
            this.$router.back();
        },
        removeCacheFormForShow: function () {
            window.sessionStorage.removeItem('form_register');
            window.sessionStorage.removeItem('accept_terms_privacy');
        },
        errorHandle: function(exception) {
            let title = this.lbl.register.error.title;
            let body = ``;
            if (exception) {
                let id = exception.id;
                let code = exception.code;
                let msg = exception.message;
                if (code == 409) {
                    if (id == 2128) {
                        if (msg == "Personal ID Registered") {
                            body = this.lbl.register.error.err_id.msg;
                        } else if (msg == "Contact Number Registered") {
                            body = this.lbl.register.error.err_number.msg;
                        } else if (msg == "Contact Number & Personal ID Registered") {
                            body = this.lbl.register.error.err_number.msg;
                        } 
                    } else if (id == 2089) {
                        if (msg == "DuplicateEmail") {
                            body = this.lbl.register.error.err_dup_email.msg;
                        }
                    } else if (id == 409) {
                        if (msg == "ReferralCode Fully Claimed") {
                            body = this.lbl.register.error.err_refcode_full.msg;
                        } else if (msg == "Invalid ReferralCode") {
                            body = this.lbl.register.error.err_invalid_refcode.msg;
                        }
                    }
                } else {
                    body = msg;
                }
            this.alertModal
                .clearText()
                .setTitle(title)
                .setMsg(body)
                .setBtnOk(this.lbl.register.validate.btn)
                .setTag("error-info")
                .show();
            }
        },
    }
}
</script>
<style lang="scss" scoped>
@import "../style/Register.scss";
@import "../style/RegisterOtp.scss";


</style>
